import React, { useState } from 'react';
import { Nullable } from 'chaika-frontend-types/backend';
import { OptionType } from '@components/Select';
import { PriceModelData } from '@store/models/Price';
import { FACTOR, Money } from '@store/models/Money';

interface Props {
    item: PriceModelData;
    onChange(item: Partial<PriceModelData>): void;
}

interface Data {
    money: string;
    onBlurMoney(event: React.FocusEvent<HTMLInputElement>): void;
    onSelectChange(params: Nullable<OptionType>, name: string): void;
    onInputMoneyChange(event: React.ChangeEvent, name: string): void;
    onInputDateChange(date: Date, name: string): void;
    onToggle(checked: boolean, name: string): void;
}

export function useHandlers({ onChange, item }: Props): Data {
    const [money, setMoney] = useState<string>(item.value?.rubles.toString() ?? '');

    function onSelectChange(params: Nullable<OptionType>, name: string): void {
        onChange({ [name]: params?.value ?? null });
    }

    function onInputMoneyChange(event: React.ChangeEvent<HTMLInputElement>, name: string): void {
        setMoney(event.target.value);
    }

    function onBlurMoney(event: React.FocusEvent<HTMLInputElement>): void {
        const value = parseMoneyStringToNumber(money);
        onChange({ [event.target.name]: new Money(value) });
    }

    function onInputDateChange(date: Date, name: string): void {
        onChange({
            [name]: date.toISOString(),
        });
    }

    function onToggle(checked: boolean, name: string): void {
        onChange({
            [name]: !checked,
        });
    }

    function parseMoneyStringToNumber(moneyString: string): number {
        return (moneyString.includes('.') ? parseFloat(moneyString) : Number(moneyString)) * FACTOR;
    }

    return {
        money,
        onBlurMoney,
        onSelectChange,
        onInputMoneyChange,
        onInputDateChange,
        onToggle,
    };
}
